/**
 * The bounds of `edgeNear` (`0x070F`, PROTOCOL.md 6.96.0, ADR-147 decisions 13 and 26): which neighbouring map's edge view
 * the gateway now sends a page, and the world version that neighbour runs. Its field table is in `text.ts`, which
 * `encodeText` and `parseTextFrame` apply.
 */

/**
 * The longest world version `edgeNear` carries, the bound `welcome.worldVersion` has.
 */
export const MAX_EDGE_NEAR_VERSION_CHARS = 64;
